import { Link, routes } from '@cedarjs/router'
import { CircularProgress, Tooltip, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useStateStore } from "src/lib/store"
import AnimatedSlidingBlock from "../AnimatedSlidingBlock/AnimatedSlidingBlock"
import ReviewPopupButton from "../Review/ReviewPopupButton/ReviewPopupButton"

const HeaderTankInfos = ({ tank = null, loading = false, failed = false, className = "" }) => {
  const { t } = useTranslation()
  const [batch, stadePL, daysOfCulture] = useStateStore(state => [state.batch, state.stadePL, state.daysOfCulture])
  return (
    <div className={`flex flex-row gap-6 ${className}`}>
      <AnimatedSlidingBlock key="header-tank">
        <Link to={!loading ? routes.tank({ idSite: tank?.site?.id, idTank: tank?.id }) : ""} className="no-underline dark:text-white/80 text-black pb-0">
          <div className="flex flex-col align-items-center justify-center items-center hover:text-blue-800 transition-colors">
            <Typography variant="h2" className="font-bold sm:text-xl lg:text-2xl text-lg">
              {loading ? <CircularProgress size={20} /> : (<>
                {tank?.name}
              </>
              )}
            </Typography>
            <Typography variant="caption" className="sm:block hidden">
              {t("labels.tank")}
            </Typography>
          </div>
        </Link>
      </AnimatedSlidingBlock>
      <AnimatedSlidingBlock key="header-batch">
        <Link to={!loading && tank?.lastBatchTransfer?.batch?.id ? routes.batch({ idBatch: tank?.lastBatchTransfer?.batch?.id, }) : ""} className="no-underline dark:text-white/80 text-black pb-0">
          <div className="flex flex-col align-items-center justify-center items-center hover:text-blue-800 transition-colors">
            <Typography variant="h2" className="font-bold sm:text-xl lg:text-2xl text-lg">
              {loading
                ? <CircularProgress size={20} />
                : (
                  tank.lastBatchTransfer?.batch
                    ?
                    <Tooltip arrow title={
                      <div className="flex flex-col items-start align-middle whitespace-nowrap">
                        <Typography variant="body1" sx={{ fontWeight: 600 }} className="flex flex-row">
                          <span className="text-white/80 flex flex-row">DoC{daysOfCulture && <span className="text-white ml-1">{daysOfCulture}</span>}</span>
                          <span className="mx-1">/</span>
                          <span className="text-white/80 flex flex-row">PL{stadePL && <span className="text-white ml-1">{stadePL}</span>}</span>
                        </Typography>
                        <Typography variant="body2">
                          {batch.quantity} PL{batch.batchInitial ? batch.batchInitial.stadePL : batch.rootBatch.batchInitial.stadePL} {batch.batchInitial ? batch.batchInitial.provider.name : batch.rootBatch.batchInitial.provider.name}
                        </Typography>
                      </div>
                    }>
                      <span>{batch.name}</span>
                    </Tooltip>
                    : t('status.tankEmpty')
                )}
            </Typography>
            <Typography variant="caption" className="sm:block hidden">
              {`${t("titles.actualBatch")}`}
            </Typography>
          </div>
        </Link>
      </AnimatedSlidingBlock>
      <AnimatedSlidingBlock key="header-state">
        {tank?.lastReview && 
        <div className="flex flex-col items-center justify-end h-full">
          <ReviewPopupButton review={tank?.lastReview} className="sm:text-xl lg:text-xl text-lg p-1" />
          <Typography variant="caption" className="sm:block hidden">
            {t("labels.review")}
          </Typography>
        </div>}
      </AnimatedSlidingBlock>
    </div >
  )
}

export default HeaderTankInfos
